import { getBreakpoint, CROSS_BREAKPOINT, MEDIUM } from './breakpoint-controller';

var $ = window.jQuery,
	activeFilter,
	el;

function onDocumentReady() {
	el = $('.filter-bar');

	if (el.length > 0) {
		$(document)
		.on(CROSS_BREAKPOINT, onCrossBreakpoint)
		.on('click', onDocumentClick);

		el.on('click', '.search-submit', onClickSearchToggle);
		el.on('click', '.filter-option-add', onClickFilterOption);
		el.on('click', '.filter-toggle, .filters-close', onClickFilterBy);
		el.on('click', '.filter-name-link', onClickFilterName);
	}
}

function onDocumentClick(e) {
	if ($(e.target).closest('.filter').length === 0) {
		setActiveFilter(false);
	}
}

/**
 * Handles switching between large and small layout UIs.
 * @param {object} e jQuery event.
 * @param {integer} breakpoint The breakpoint in pixels.
 */
function onCrossBreakpoint(e, breakpoint) {
	setActiveFilter(false);

	if (breakpoint >= MEDIUM) {
		largeInterface();
	} else {
		smallInterface();
	}
}

/**
 * Enables small layout UI
 */
function smallInterface() {
	el.find('.filters').hide();
	el.find('.filter-options').show().removeAttr('style');
}

/**
 * Enables large layout UI.
 */
function largeInterface() {
	el.find('.filters').show().removeAttr('aria-hidden');
	el.find('.filter-options').hide().removeAttr('style');
}

/**
 * Handles the filter option click event. Only handles UI changes.
 */
function onClickFilterOption() {
	if (getBreakpoint() >= MEDIUM) {
		setActiveFilter(false);
	} else {
		 el.find('.filters').stop().slideToggle(200);
	}
}

/**
 * Handles the filter name click event.
 * @param {object} e jQuery event
 */
function onClickFilterName(e) {
	var filter = $(e.currentTarget).closest('.filter').get(0);
	toggleFilter(filter);

	return false;
}

/**
 * Handles the search filter submit button click event.
 * @param {object} e jQuery event
 */
function onClickSearchToggle(e) {
	el.find('input[type="search"]').focus();

	return false;
}

/**
 * Handles the filters toggle click event.
 * @param {object} e jQuery event
 */
function onClickFilterBy(e) {
	e.stopImmediatePropagation();

	var toggle = el.find('.filter-toggle'),
		showResults = el.find('.filters-close'),
		filters = el.find('.filters');

	filters.stop().slideToggle(200);
	filters.attr('aria-hidden', filters.attr('aria-hidden') === 'true' ? 'false' : 'true');
	toggle.attr('aria-expanded', toggle.attr('aria-expanded') === 'true' ? 'false' : 'true');
	showResults.attr('aria-expanded', showResults.attr('aria-expanded') === 'true' ? 'false' : 'true');

	return false;
}

function _openFilter(filter) {
	const $filter = $(filter);
	const $filterOpts = $filter.find('.filter-options');

	$filter.addClass('active').attr('aria-expanded', 'true');
	$filterOpts.stop(true, false).css('display', 'flex').hide().slideDown();
}

function _closeFilter(filter) {
	const $filter = $(filter);
	const $filterOpts = $filter.find('.filter-options');

	$filter.removeClass('active').attr('aria-expanded', 'false')
	$filterOpts.stop(true, false).slideUp();
}

function toggleFilter(filter) {
	if (filter === activeFilter) {
		setActiveFilter(false);
	} else {
		setActiveFilter(filter);
	}
}

function setActiveFilter(filter) {
	if (activeFilter !== filter) {
		if (activeFilter) {
			_closeFilter(activeFilter);
		}

		if (filter) {
			_openFilter(filter);
		}

		activeFilter = filter;
	}
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
